import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAuth } from '../context/AuthContext';

const SessionKeepAlive = () => {
  const { refreshSession } = useAuth();
  const location = useLocation();

  useEffect(() => {
    void refreshSession();
  }, [location.pathname, location.search, refreshSession]);

  useEffect(() => {
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible')
        void refreshSession();
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => document.removeEventListener('visibilitychange', onVisibilityChange);
  }, [refreshSession]);

  return null;
};

export default SessionKeepAlive;
